import styled from "styled-components";

import { card } from "/styles";

export const ListContainer = styled.div(card.wrapper);
